import React, { useReducer, useContext, useLayoutEffect } from 'react'
import { lockedReducer } from '../../Utils/reducers'
import { api } from '../../../services/api'
import ColorButton from '../../Buttons/ColorButton';
import DefaultModal from '../../Utils/DefaultModal';
import toast from 'react-hot-toast'
import { Box, Tooltip, TextField, List, ListItem, ListItemText, ListItemAvatar, Avatar } from '@mui/material'
import validateData from './validateData';
import { externalComponent } from '../../AppRoutes';
import { avatars } from '.';

const url = '/execution_log/'

export const translate_permissions_keys = {
    'Can': '',
    'add': 'Adicionar',
    'change': 'Alterar',
    'delete': 'Excluir',
    'view': 'Ver'
}


const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const initialize = async (id, setState, setLoader) => {
    setLoader(true)
    const res = await api.get(url+id+'/')
    if (res.status === 200){
        setState(res.data)
    }
    setLoader(false)
}

const EditExecutionLogsModal = ({ data, handleClose, permissions, reloadData }) => {

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        id: data.id ? data.id : 0,
        name: data.name ? data.name : '',
        log_content: data.log_content ? data.log_content : {events:[]},
    })

    useLayoutEffect(()=>{
        initialize(data.id, setState, setLoader)
    }, [])

    const validData = validateData(state)

    return (
        <>
            <DefaultModal
                title={
                    `${getTitle(state)} Logs de execução`
                }
                handleClose={handleClose}
                content={
                    <>
                        <Box className='item-content-modal noborder' sx={{overflow:'hidden'}} >
                            <Box className='item-profile-row'>
                                <TextField
                                    id="name"
                                    type="text"
                                    label="Nome"
                                    disabled
                                    value={state.name}
                                    onChange={(e) => { setState({ 'name': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 50
                                    }}
                                />
                            </Box>
                            
                            <Box className='item-profile-row' sx={{overflow:'auto'}}>
                                <List className='execution_logs-events-list' sx={{ width: '100%' }}>
                                {state.log_content.events.map((event, index) => (
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar>
                                                {avatars[event.event_type]}
                                            </Avatar>
                                        </ListItemAvatar>
                                        <Tooltip title={event.description}  placement="bottom-start"
                                            PopperProps={{ modifiers: [{ name: "offset", options: { offset: [0, -15], }, }] }}>
                                            <ListItemText primary={event.event_name} secondary={event.timestamp} />
                                        </Tooltip>
                                    </ListItem>
                                ))}
                                </List>
                            </Box>
                        </Box>
                    </>
                }
            />
        </>
    )
}

export default EditExecutionLogsModal